import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import { PiTShirt } from "react-icons/pi";
import { CiCamera } from "react-icons/ci";
import { IoBagAddOutline } from "react-icons/io5";
import { TbWashHand } from "react-icons/tb";
import { AiOutlineHome } from "react-icons/ai";
import { FaCarSide } from "react-icons/fa";
import { IoBulbOutline } from "react-icons/io5";
import { RxChevronRight } from "react-icons/rx";
import { PiHouseLineBold } from "react-icons/pi";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import "../../assets/css/Add_Product.css";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import NoZoomWrapper from "../../utils/NoZoomWrapper";

const Add_Product = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState(null); // Changed to null
  const subcategoryRef = useRef(null);
  const { t } = useTranslation();

  const handleClick = (categoryId, category, subcategory) => {
    // console.log("category Id::", categoryId);
    if (subcategory) {
      navigate(`/Add-Product/${category}/${subcategory}`, {
        state: {
          categoryId: categoryId,
        },
      });
    } else {
      navigate(`/Add-Product/${category}`, {
        state: {
          categoryId: categoryId,
        },
      });
    }
  };

  const handleCategoryClick = (category, event) => {
    if (selectedCategory && selectedCategory.name === category.name) {
      // If the same category is clicked again, close the dropdown
      setSelectedCategory(null);
      setDropdownPosition(null);
    } else if (category.subcategories.length === 0) {
      // If no subcategories, navigate directly
      handleClick(category.id, category.name);
      setSelectedCategory(null);
      setDropdownPosition(null);
    } else {
      // Open the dropdown and set its position
      setSelectedCategory(category);
      const rect = event.currentTarget.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 10, // 10px below the button
        left: rect.left,
        width: rect.width,
      });
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        subcategoryRef.current &&
        !subcategoryRef.current.contains(event.target) &&
        !event.target.closest(".categor-item")
      ) {
        // Ignore clicks on the category item itself
        setSelectedCategory(null);
        setDropdownPosition(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCategories = async () => {
    try {
      const response = await fetch("https://network.rentel.in/categories/get");
      const data = await response.json();
      const formattedCategories = data["categories"].map((category) => {
        return {
          id: category._id,
          color: category.colorCode,
          icon: category.image,
          name: category.name,
          subcategories: category.subCategories || [],
          isDelete: category.isDelete,
        };
      });
      setDropdownOptions(formattedCategories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const [categories, setDropdownOptions] = useState([
    {
      name: "Cloth",
      icon: <PiTShirt />,
      subcategories: ["Men", "Women", "Children"],
      className: "category-blue",
    },
    {
      name: "Camera",
      icon: <CiCamera />,
      subcategories: [],
      className: "category-orange",
    },
    {
      name: "Electronics",
      icon: <IoBulbOutline />,
      subcategories: [],
      className: "category-red",
    },
    {
      name: "Clinic",
      icon: <IoBagAddOutline />,
      subcategories: [],
      className: "category-blue",
    },
    {
      name: "Cleaning",
      icon: <TbWashHand />,
      subcategories: [],
      className: "category-blue",
    },
    {
      name: "Property",
      icon: <AiOutlineHome />,
      subcategories: [],
      className: "category-orange",
    },
    {
      name: "Car",
      icon: <FaCarSide />,
      subcategories: [],
      className: "category-blue",
    },
    {
      name: "Farm",
      icon: <PiHouseLineBold />,
      subcategories: [],
      className: "category-yellow",
    },
    {
      name: "Bike",
      icon: <PiHouseLineBold />,
      subcategories: [],
      className: "category-orange",
    },
  ]);

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Header />
          <div className="container">
            <div className="product-page">
              <h1 className="heading">{t("what_are_you_offering")}</h1>
              <div className="categories">
                {categories.map((category, index) => (
                  <div
                    key={index}
                    className={`categor-item ${category.className}`}
                    style={{
                      backgroundColor: `#${category.color}`,
                      position: "relative",
                    }}
                    onClick={(event) => handleCategoryClick(category, event)}
                  >
                    <div className="iconam">
                      {typeof category.icon === "string" ? (
                        <img
                          src={category.icon}
                          alt={category.name}
                          className="icone"
                        />
                      ) : (
                        category.icon
                      )}
                      <span className="namee">{category.name}</span>
                    </div>
                    <span className="arrow">
                      <RxChevronRight />
                    </span>

                    {selectedCategory &&
                      selectedCategory.name === category.name && (
                        // Add the ref here
                        <div className="subcategories" ref={subcategoryRef}>
                          <div className="subcategor-list">
                            {selectedCategory.subcategories.map((sub, idx) => (
                              <div
                                key={idx}
                                className="subcategor-item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClick(
                                    selectedCategory.id,
                                    selectedCategory.name,
                                    sub
                                  );
                                }}
                              >
                                {capitalizeFirstLetter(sub)}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Add_Product;
